import first from 'lodash/first';
import eq from 'lodash/isEqualWith';
import { TYPES } from './actions';
import { get, unshift, pop } from '../../../utils/state';

export const initialState = {
  history: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TYPES.SET_HISTORY: {
      const historyTop = first(get(state, 'history'));
      if (eq(action.payload, historyTop)) {
        return state;
      }
      return unshift(state, 'history', action.payload);
    }
    case TYPES.POP_HISTORY: {
      return pop(state, 'history');
    }
    default:
      return state;
  }
}
